// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__I9P2C","caption":"styles_caption__b2-uC","copyText":"styles_copyText__Fjppe"};